<script setup>
const { locale } = useI18n()
const story = await useAsyncStoryblok('career-at-dexon-index', { version: 'publish', language: locale.value, })
useBreadcrumbSchema(story.value?.content?.title)
useHead({
  title: story.value?.content.title,
  meta: [
    {
      name: 'description',
      content: story.value?.content.description,
    },
    {
      name: 'keywords',
      content: story.value?.content.keyword,
    },
    {
      property: 'og:title',
      content: story.value?.content.title,
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:locale',
      content: 'en_US',
    },
    {
      property: 'og:description',
      content: story.value?.content.description,
    },
    {
      property: 'og:image',
      content: story.value?.content.thumbnail?.filename,
    },
    {
      property: 'og:url',
      content: `https://www.dexon-technology.com/${story.value?.full_slug}`,
    },
    {
      name: 'twitter:card',
      content: story.value?.content.thumbnail?.filename,
    },
    {
      name: 'twitter:title',
      content: story.value?.content.title,
    },
    {
      name: 'twitter:description',
      content: story.value?.content.description,
    },
    {
      name: 'twitter:image',
      content: story.value?.content.thumbnail?.filename,
    },
  ],
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        'name': story.value?.content.title,
        'description': story.value?.content.description,
        'url': 'https://www.dexon-technology.com/career-at-dexon',
        'isPartOf': {
          '@type': 'Organization',
          'name': 'Dexon Technology',
        },
      }),
    },
  ],
})
</script>

<template>
  <StoryblokComponent v-if="story?.content" :blok="story.content" />
</template>
